module.exports = __webpack_public_path__ + "static/media/room-6.b9a34e96.jpeg";